var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightGreenCircle = function SvgLightGreenCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 381,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.065 371C290.752 371 371.565 290.187 371.565 190.5C371.565 90.8126 290.752 10 191.065 10C91.3775 10 10.5649 90.8126 10.5649 190.5C10.5649 290.187 91.3775 371 191.065 371ZM191.065 381C296.275 381 381.565 295.71 381.565 190.5C381.565 85.2898 296.275 0 191.065 0C85.8546 0 0.564861 85.2898 0.564861 190.5C0.564861 295.71 85.8546 381 191.065 381Z",
    fill: "#C7F700"
  })));
};
export default SvgLightGreenCircle;